import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import './styles.css';

/**
 *  AccessoryBodyTypeTabName
 */
class AccessoryBodyTypeTabName extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    anchorPoint: PropTypes.string,
    anchorName: PropTypes.string,
    bodyTypeName: PropTypes.string,
    bodyTypeTabName: PropTypes.string
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    anchorPoint: null,
    anchorName: null,
    bodyTypeName: null,
    bodyTypeTabName: null
  };
  
  constructor(props) {
    super();
    this.props = props;
  }
  
  render() {
    const {
      containerId,
      containerClass,
      anchorPoint,
      anchorName,
      bodyTypeName,
      bodyTypeTabName
    } = this.props;
        
    //
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
        anchorPoint={anchorPoint}
        anchorName={anchorName}
      >
        <div className='AccessoryBodyTypeTabName'>
        </div>
      </Wrapper>
    )
  }
  
}

export default AccessoryBodyTypeTabName;



// WEBPACK FOOTER //
// ./src/containers/accessory-body-type-tab-name/index.jsx